import React from 'react';
import DefaultIconSrc from 'oldAssets/images/icons/check-black.svg';
import styles from './TileWithIcon.module.scss';

const defaultIcon = {
  src: DefaultIconSrc,
  width: 38,
  height: 31
};

const TileWithIcon = ({
  title,
  text,
  number,
  icon = defaultIcon,
  description
}) => {
  const iconBlock = (typeof icon === 'string') ?
    <img src={ icon } /> :
    <img { ...icon } />;

  const descriptionBlock = description ?
    description :
    <p className={ styles.description }>{ text }</p>;

  return (
    <div className={ styles.TileWithIcon }>
      <div className={ styles.iconWrapper }>
        <figure className={ styles.icon }>{ iconBlock }</figure>
      </div>
      { title && <h4>{ title }</h4> }
      { descriptionBlock }
      { number && <div className={ styles.numberBack }>{ number }</div> }
    </div>
  );
};

export default TileWithIcon;
